import { SmartSendProvider } from '~/lib/consts/providers';
import { CustomerServiceTag, QuoteApiModel, QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { P2GText } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GChip } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { FavouriteIncludeServiceTags } from '../utils/CurrentSelectionType';
import { P2GIcon } from '@parcel2go/core-ui';
import SvgHeart from '../Heart';
import SvgHeartOutline from '../HeartOutline';
import { P2GLink } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export interface QuoteCardProps {
  quote: QuoteApiModel;
  estimatedValue?: number;
  onSave: (quote: QuoteApiModel, option: QuoteOptionApiModel) => void;
  currentSelection: { accountId: string; id: string; extras: string[] };
  serviceTags: string[];
  updateServiceTags: (add: CustomerServiceTag[], remove: CustomerServiceTag[]) => void;
  toggleSpecificTag: (tag: CustomerServiceTag) => void;
  maxQuoteOptions: number;
  isXs: boolean;
}

export function QuoteCardList(props: QuoteCardProps) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const toggleFavourite = () =>
    props.toggleSpecificTag({
      ServiceSlug: props.quote.Service.Id,
      GroupIdentifier: SmartSendProvider,
      Tags: FavouriteIncludeServiceTags
    });
  const onSave = () => props.onSave(props.quote, props.quote.Options[0]);
  const isFavourite = FavouriteIncludeServiceTags.every((t) => props.serviceTags.includes(t));
  const checked = props.currentSelection.id === props.quote.Service.Id;

  return (
    <P2GBox pt={1} pb={1} pl={2} pr={2} bordered>
      <P2GGrid container alignItems="center" gap={1} wrap="nowrap">
        {props.quote.Service.CourierProductCode && (
          <P2GGrid item>
            <div style={{ minWidth: '55px' }}>
              <P2GChip size="small" color="primary" label={props.quote.Service.CourierProductCode} />
            </div>
          </P2GGrid>
        )}
        <P2GGrid item flexGrow={1} onClick={onSave}>
          <P2GText variant={props.isXs ? 'body2' : 'body1'}>{props.quote.Service.Name}</P2GText>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <div onClick={toggleFavourite} style={{ cursor: 'pointer' }}>
            <P2GIcon size="sm" palette="primary">
              {isFavourite ? <SvgHeart /> : <SvgHeartOutline />}
            </P2GIcon>
          </div>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <P2GCheckBoxLegacy
            checked={checked}
            onChange={onSave}
            label={
              <P2GLink underline="none">
                <strong>{t('QUOTE_OPTION_INPUT_LABEL', { defaultValue: 'Select' })}</strong>
              </P2GLink>
            }
            id="QuoteId"
            labelPlacement="end"
            variant="primary"
            error={false}
          />
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  );
}
